// extracted by mini-css-extract-plugin
export var chevronIcon = "_4e-2";
export var teamName = "_4e-1";
export var teamSwitcherButton = "_4e-0";